import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { Checkbox, type CheckboxProps } from '@/components/controls';

export type FormCheckboxProps = Omit<CheckboxProps, 'checked'> & {
  control?: Control;
};

export const FormCheckbox = ({
  name,
  control,
  ...props
}: FormCheckboxProps) => {
  return (
    <Controller
      name={name as string}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <Checkbox
            {...props}
            onChange={(event) => onChange(event.currentTarget.checked)}
            checked={value}
          />
        );
      }}
    />
  );
};

FormCheckbox.displayName = 'Form.Checkbox';

export const required = (message = 'The field is required') => {
  return z.boolean({ message }).refine((value) => value === true, {
    message,
  });
};

FormCheckbox.rules = { required };
